/**
 * Minimal i18n setup for the landings project.
 *
 * Only Italian. No language detector. No HTTP backend.
 * Just the keys the shared ContactForm component needs so its
 * `useTranslation()` calls resolve correctly.
 *
 * If the shared component adds new t('...') keys in the future,
 * add them to ./locales/it.ts below and the form keeps working
 * without a code change here.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { it } from './locales/it'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
    },
    lng: 'it',
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    returnNull: false,
  })

export default i18n
